import http from '../../../service/axios';
import { waitForMindboxDeviceUUID } from '../../../lib/mindbox';

export const homeAPI = {
  getCategories: async () => await http.get('/categories'),
  getMenus: async (branchID: number) =>
    await http.get('/menu/list-new', {
      params: {
        date: new Date().toISOString(),
        branch: branchID,
      },
    }),
  searchProducts: async (branch: number, query: string) =>
    await http.get('/product-search/index', {
      params: {
        search: query,
          branch,
      },
    }),
  // Баннеры и сторис зависят от филиала: бэк отдаёт свою подборку на branch_id.
  // Филиал может быть неизвестен (нет адреса и выключена геолокация) — тогда
  // параметр не уходит вовсе, и бэк отдаёт общую подборку.
  getBanners: async (branchId?: number) =>
    await http.get('/banner/list', {
      params: {
        branch_id: branchId || undefined,
      },
      headers: {
        version: '3.2.0',
      },
    }),
  getStories: async (language: string, branchId?: number) =>
    await http.get('/story', {
      params: {
        branch_id: branchId || undefined,
      },
      headers: {
        // 'Accept-Language': language,
        'Language': language,
      },
    }),
  getSettings: async () => await http.get('/settings/settings'),
  getMindboxUserInfo: async () =>
    await http.get('/mb/user-info', {
      params: {
        deviceUUID: await waitForMindboxDeviceUUID(),
      },
    }),
};
